import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { formattedCountries } from './formattedCountries';
const CompanyMarketRelatedFields = _ref => {
  var _company$has_made_cla, _company$has_made_cla2, _window$MARKET_CONSTA;
  let {
    company,
    handleChange,
    admins
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('company_name')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.excel_name,
    name: "excel_name",
    onChange: handleChange,
    disabled: user.account_type !== 'admin' && user.account_type !== 'super_consultant',
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "".concat(t('company_name'), " (Kimble)"), "*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.name,
    name: "name",
    disabled: user.account_type !== 'admin',
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, "".concat(t('company_abbrevieted_name'), " (Internal)")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.abbreviated_name || '',
    name: "abbreviated_name",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('company_familygroup_name')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.company_family_group_name || '',
    name: "company_family_group_name",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridLegalRepTitle"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('legal_rep_title')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    placeholder: t('legal_rep_title'),
    onChange: handleChange,
    name: "legal_rep_title",
    value: company.legal_rep_title || ''
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridLegalRepLastName"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('legal_rep_last_name')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: handleChange,
    name: "legal_rep_last_name",
    placeholder: t('legal_rep_last_name'),
    value: company.legal_rep_last_name || ''
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridLegalRepFirstName"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('legal_rep_first_name')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "legal_rep_first_name",
    onChange: handleChange,
    placeholder: t('legal_rep_first_name'),
    value: company.legal_rep_first_name || ''
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridEmail"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('street')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    placeholder: t('street'),
    onChange: handleChange,
    name: "street",
    value: company.street
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridPassword"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('house_number')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: handleChange,
    name: "house_number",
    placeholder: t('house_number'),
    value: company.house_number
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridPassword"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('house_number_suppliment')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "house_number_suppliment",
    onChange: handleChange,
    placeholder: t('house_number_suppliment'),
    value: company.house_number_suppliment
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridEmail"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('location')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    placeholder: t('location'),
    onChange: handleChange,
    name: "location",
    value: company.location
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridPassword"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('post_code')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    onChange: handleChange,
    name: "postcode",
    placeholder: t('post_code'),
    value: company.postcode
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridPassword"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('address_suppliment')), /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    name: "address_suppliment",
    onChange: handleChange,
    placeholder: t('address_suppliment'),
    value: company.address_suppliment
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    className: "col-md-6",
    controlId: "formGridEmail"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('country')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: company.country,
    name: "country",
    onChange: handleChange,
    size: "md"
  }, formattedCountries.map(country => {
    return /*#__PURE__*/React.createElement("option", {
      key: country,
      value: country
    }, t(country));
  }))), company.country === 'germany' && /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    controlId: "formGridPassword"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('federal_state')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: company.federal_state,
    name: "federal_state",
    onChange: handleChange,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), /*#__PURE__*/React.createElement("option", {
    value: "baden_wuerttemberg"
  }, t('baden_wuerttemberg')), /*#__PURE__*/React.createElement("option", {
    value: "bayern"
  }, t('bayern')), /*#__PURE__*/React.createElement("option", {
    value: "berlin"
  }, t('berlin')), /*#__PURE__*/React.createElement("option", {
    value: "brandenburg"
  }, t('brandenburg')), /*#__PURE__*/React.createElement("option", {
    value: "bremen"
  }, t('bremen')), /*#__PURE__*/React.createElement("option", {
    value: "hamuburg"
  }, t('hamuburg')), /*#__PURE__*/React.createElement("option", {
    value: "hesse"
  }, t('hesse')), /*#__PURE__*/React.createElement("option", {
    value: "mecklenburg_vorpommern"
  }, t('mecklenburg_vorpommern')), /*#__PURE__*/React.createElement("option", {
    value: "lower_saxony"
  }, t('lower_saxony')), /*#__PURE__*/React.createElement("option", {
    value: "north_rhine_westphalia"
  }, t('north_rhine_westphalia')), /*#__PURE__*/React.createElement("option", {
    value: "rheinland_pfalz"
  }, t('rheinland_pfalz')), /*#__PURE__*/React.createElement("option", {
    value: "saarland"
  }, t('saarland')), /*#__PURE__*/React.createElement("option", {
    value: "saxony"
  }, t('saxony')), /*#__PURE__*/React.createElement("option", {
    value: "saxony_anhalt"
  }, t('saxony_anhalt')), /*#__PURE__*/React.createElement("option", {
    value: "schleswig_holstein"
  }, t('schleswig_holstein')), /*#__PURE__*/React.createElement("option", {
    value: "thuringia"
  }, t('thuringia'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('claimed_rd_tax_credits_before'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    type: "radio",
    label: t('yes'),
    value: "true",
    checked: ((_company$has_made_cla = company.has_made_claims_before) === null || _company$has_made_cla === void 0 ? void 0 : _company$has_made_cla.toString()) === 'true',
    name: "has_made_claims_before",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(Form.Check, {
    inline: true,
    type: "radio",
    label: t('no'),
    value: "false",
    checked: ((_company$has_made_cla2 = company.has_made_claims_before) === null || _company$has_made_cla2 === void 0 ? void 0 : _company$has_made_cla2.toString()) === 'false',
    name: "has_made_claims_before",
    onChange: handleChange,
    size: "md"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('legal_form'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: company.legal_form || '',
    name: "legal_form",
    onChange: handleChange,
    size: "md"
  }, (_window$MARKET_CONSTA = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA === void 0 || (_window$MARKET_CONSTA = _window$MARKET_CONSTA.LEGAL_FORM_OPTIONS) === null || _window$MARKET_CONSTA === void 0 ? void 0 : _window$MARKET_CONSTA.map(option => /*#__PURE__*/React.createElement("option", {
    key: option.value,
    value: option.value
  }, t(option.translationKey)))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('tax_group')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.tax_group || '',
    name: "tax_group",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('company_unique_tax_reference_utr')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.utr || '',
    name: "utr",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('industrysector_sic')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.sic_codes || '',
    name: "sic_codes",
    onChange: handleChange,
    size: "md",
    type: "text",
    disabled: user.account_type !== 'admin' && user.account_type !== 'super_consultant'
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('sales_ma')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: company.sales_ma || '',
    name: "sales_ma",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('contract_date')), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'contract_date'
      }
    }),
    selected: company.contract_date
  }))))));
};
export default CompanyMarketRelatedFields;